// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2mfg-","alertIcon":"ConfirmModal_alertIcon__1BjF7"};